import styled from '@emotion/styled'
import { isMobile } from '@const/device'

const DesktopWrapper = styled.div`
  display: flex;
`
const MobileWrapper = styled(DesktopWrapper)`
  position: absolute;
  z-index: 500;
  background-color: white;
  padding: 25px;
  width: 100%;
`
export const Wrapper = isMobile ? MobileWrapper : DesktopWrapper

export const BurgerWrapper = styled.div`
  cursor: pointer;
  margin-right: 13px;
`

export const MainLogoWrapper = styled.div`
  padding-top: ${() => (isMobile ? '1px' : '3px')};
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const BellWrapper = styled.div`
  margin-top: -10px;
  margin-right: -10px;
  position: absolute;
  z-index: 1000;
  right: 10px;
  top: 25px;
`

// Лого компании грузится произвольным файлом (png/svg/jpg, любые пропорции),
// в отличие от ReactComponent-лого ШЭ со своим фиксированным viewBox.
// Раньше ограничивался только шириной (25/50px) без высоты — квадратные и
// высокие логотипы растягивали строку меню. Ограничиваем обе стороны и
// не обрезаем пропорции (object-fit: contain).
export const CompanyLogoImg = styled.img`
  max-height: ${() => (isMobile ? '28px' : '60px')};
  max-width: ${() => (isMobile ? '120px' : '170px')};
  width: auto;
  height: auto;
  object-fit: contain;
`

// DesktopMenu в свёрнутом виде (SMALL_WIDTH=45, свой SmallLogo 20×20) —
// тот же компонент не влезет, нужна отдельная мерка под рельс.
export const CompanyLogoImgCollapsed = styled.img`
  max-height: 32px;
  max-width: 30px;
  width: auto;
  height: auto;
  object-fit: contain;
`
